import createIcon from '../../createIcon';

/**
 * @component @name Groups3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuMjQgMTMuNjVDMTUuMDcgMTMuMTMgMTMuNjMgMTIuNzUgMTIgMTIuNzVDMTAuMzcgMTIuNzUgOC45MyAxMy4xNCA3Ljc2IDEzLjY1QzYuNjggMTQuMTMgNiAxNS4yMSA2IDE2LjM5VjE4SDE4VjE2LjM5QzE4IDE1LjIxIDE3LjMyIDE0LjEzIDE2LjI0IDEzLjY1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEuMjIgMTQuNThDMC40OCAxNC45IDAgMTUuNjIgMCAxNi40M1YxOEg0LjVWMTYuMzlDNC41IDE1LjU2IDQuNzMgMTQuNzggNS4xMyAxNC4xQzQuNzYgMTQuMDQgNC4zOSAxNCA0IDE0QzMuMDEgMTQgMi4wNyAxNC4yMSAxLjIyIDE0LjU4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIyLjc4IDE0LjU4QzIxLjkzIDE0LjIxIDIwLjk5IDE0IDIwIDE0QzE5LjYxIDE0IDE5LjI0IDE0LjA0IDE4Ljg3IDE0LjFDMTkuMjcgMTQuNzggMTkuNSAxNS41NiAxOS41IDE2LjM5VjE4SDI0VjE2LjQzQzI0IDE1LjYyIDIzLjUyIDE0LjkgMjIuNzggMTQuNThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgMTJDMTMuNjYgMTIgMTUgMTAuNjYgMTUgOUMxNSA3LjM0IDEzLjY2IDYgMTIgNkMxMC4zNCA2IDkgNy4zNCA5IDlDOSAxMC42NiAxMC4zNCAxMiAxMiAxMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0zLjk5OTkgOC40OTY4N0wxLjQ5Njc3IDExTDMuOTk5OSAxMy41MDMxTDYuNTAzMDMgMTFMMy45OTk5IDguNDk2ODdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAgOUwxNy41IDEzSDIyLjVMMjAgOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Groups3 = createIcon('Groups3', [
  [
    'path',
    {
      d: 'M16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65Z',
      key: 'mqtrc2',
    },
  ],
  [
    'path',
    {
      d: 'M1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58Z',
      key: 'k0yvrv',
    },
  ],
  [
    'path',
    {
      d: 'M22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43C24 15.62 23.52 14.9 22.78 14.58Z',
      key: '1tr324',
    },
  ],
  [
    'path',
    {
      d: 'M12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12Z',
      key: '1bxsu4',
    },
  ],
  [
    'path',
    { d: 'M3.9999 8.49687L1.49677 11L3.9999 13.5031L6.50303 11L3.9999 8.49687Z', key: 'zjpeek' },
  ],
  ['path', { d: 'M20 9L17.5 13H22.5L20 9Z', key: 'k32rof' }],
]);

export default Groups3;
